$(document).on("turbo:load", initGpsPointsMap);

function initGpsPointsMap(){
  $('#gps-map').locationpicker({
    location: {latitude: $('#gps-map').data('lat'), longitude:  $('#gps-map').data('lon')}, 
    radius: parseInt($("#gps_point_radius").val()),
    zoom: 18,
    inputBinding: {
      latitudeInput: $('#gps_point_lat'),
      longitudeInput: $('#gps_point_lon'),
      radiusInput: $('#gps_point_radius'),
      locationNameInput: $('#location_search')        
    },
    enableAutocomplete: true,
    mapTypeControl: true
  });
}
